var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import differenceBy from 'lodash/differenceBy';
import { CUSTOM_LOGIC_SUBSCRIPTION_TYPE, } from './models';
import { APP_OPTION_LIST, BLOCK_CREATE, BLOCK_DELETE, BLOCK_DUPLICATE, BLOCK_UPDATE, CONNECTOR_CREATE, CONNECTOR_DELETE, CONNECTOR_UPDATE, CUSTOM_LOGIC_CREATE, CUSTOM_LOGIC_DELETE, CUSTOM_LOGIC_READ, CUSTOM_LOGIC_READ_ALL, CUSTOM_LOGIC_UPDATE, DUPLICATE_CUSTOM_LOGIC, RESET_SELECTED_CUSTOM_LOGIC, SET_CANVAS_OFFSET, SET_CANVAS_SELECTION, SET_CHANGES_SAVING_STATE, SET_CUSTOM_LOGIC_SUBSCRIPTION, SET_DELETE_CONFIRMATION_MODAL_VISIBILITY, SET_DUPLICATE_CONFIG_MODAL_VISIBILITY, SET_DYNAMIC_MODAL_VISIBILITY, SET_OUTPUT_PARAM_SYNC, SET_PROPERTIES_BAR_VISIBILITY, SET_SELECTED_CUSTOM_LOGIC, SET_SELECTED_ENTITY, } from './constants';
import services from '../../services';
import { appendOutToName, cleanEdgeArgName, cleanPatchOutputs, } from '../../containers/StructureBuilderPage/helpers';
import { getPatchwork } from '../../containers/StructureBuilderPage/actions';
import toast from '../../components/Toast';
var PatchworkService = services.PatchworkService, AppService = services.AppService;
//region General
export var setSelectedCustomLogicAction = function (logicPatchworkId) {
    return function (dispatch) {
        dispatch({ type: SET_SELECTED_CUSTOM_LOGIC, logicPatchworkId: logicPatchworkId });
    };
};
export var resetSelectedCustomLogicAction = function (dispatch) {
    dispatch({ type: RESET_SELECTED_CUSTOM_LOGIC });
};
export var setPropertiesBarVisibilityAction = function (visibility) {
    return function (dispatch) {
        dispatch({ type: SET_PROPERTIES_BAR_VISIBILITY, visibility: visibility });
    };
};
export var setDeleteConfirmationModalVisibilityAction = function (visibility) {
    return function (dispatch) {
        dispatch({ type: SET_DELETE_CONFIRMATION_MODAL_VISIBILITY, visibility: visibility });
    };
};
export var showDuplicateConfigModalVisibilityAction = function () { return function (dispatch) {
    dispatch({ type: SET_DUPLICATE_CONFIG_MODAL_VISIBILITY, visibility: true });
}; };
export var hideDuplicateConfigModalVisibilityAction = function () { return function (dispatch) {
    dispatch({
        type: SET_DUPLICATE_CONFIG_MODAL_VISIBILITY,
        visibility: false,
    });
}; };
export var setDynamicModalVisibilityAction = function (visibility) {
    return function (dispatch) {
        dispatch({ type: SET_DYNAMIC_MODAL_VISIBILITY, visibility: visibility });
    };
};
export var setCanvasSelectionAction = function (selected) { return function (dispatch) {
    dispatch({ type: SET_CANVAS_SELECTION, selected: selected });
}; };
export var setSelectedEntityAction = function (entity) {
    return function (dispatch) {
        dispatch({ type: SET_SELECTED_ENTITY, entity: entity });
    };
};
export var updateCanvasOffset = function (offset) {
    if (offset === void 0) { offset = { x: 0, y: 0 }; }
    return function (dispatch) {
        dispatch({ type: SET_CANVAS_OFFSET, offset: offset });
    };
};
export var updateOutputParamSync = function (data) {
    return function (dispatch) {
        dispatch({ type: SET_OUTPUT_PARAM_SYNC, data: data });
    };
};
export var setChangesLoadingState = function (isSaving) { return function (dispatch) {
    dispatch({ type: SET_CHANGES_SAVING_STATE, state: !!isSaving });
}; };
export var setCustomLogicSubscription = function (payload) {
    return function (dispatch) {
        dispatch({ type: SET_CUSTOM_LOGIC_SUBSCRIPTION, payload: payload });
    };
};
export var getAppOptionListAction = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var options, _e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: APP_OPTION_LIST.REQUEST });
                return [4 /*yield*/, AppService.getAppOptionsList()];
            case 1:
                options = (_a.sent()).objects;
                dispatch({ type: APP_OPTION_LIST.SUCCESS, options: options });
                return [3 /*break*/, 3];
            case 2:
                _e_1 = _a.sent();
                dispatch({ type: APP_OPTION_LIST.ERROR });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
//endregion
//region Custom Logic
export var customLogicCreateAction = function (appId, name) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var customLogic, _e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, 5, 6]);
                    dispatch(setChangesLoadingState(true));
                    dispatch({ type: CUSTOM_LOGIC_CREATE.REQUEST });
                    if (!(appId && name)) return [3 /*break*/, 3];
                    return [4 /*yield*/, PatchworkService.createLogicPatchwork(appId, name)];
                case 1:
                    customLogic = (_a.sent()).object;
                    if (!(customLogic === null || customLogic === void 0 ? void 0 : customLogic.id)) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(customLogicReadAllAction(appId))];
                case 2:
                    _a.sent();
                    dispatch({ type: CUSTOM_LOGIC_CREATE.SUCCESS, data: customLogic });
                    _a.label = 3;
                case 3: return [3 /*break*/, 6];
                case 4:
                    _e_2 = _a.sent();
                    dispatch({ type: CUSTOM_LOGIC_CREATE.ERROR });
                    return [3 /*break*/, 6];
                case 5:
                    dispatch(setChangesLoadingState());
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
};
export var resetCustomLogicCreateStateAction = function (dispatch) {
    dispatch({ type: CUSTOM_LOGIC_CREATE.RESET });
};
export var customLogicReadAction = function (id, isRefresh, cb, silentUpdate) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var customLogic, _e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch({
                        type: CUSTOM_LOGIC_READ.REQUEST,
                        isRefresh: isRefresh,
                        silentUpdate: silentUpdate,
                    });
                    if (!id) return [3 /*break*/, 2];
                    return [4 /*yield*/, PatchworkService.readPatchwork(id)];
                case 1:
                    customLogic = (_a.sent()).object;
                    if (customLogic === null || customLogic === void 0 ? void 0 : customLogic.id) {
                        dispatch({
                            type: CUSTOM_LOGIC_READ.SUCCESS,
                            data: customLogic,
                        });
                        cb === null || cb === void 0 ? void 0 : cb(customLogic);
                    }
                    _a.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    _e_3 = _a.sent();
                    dispatch({ type: CUSTOM_LOGIC_READ.ERROR });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var customLogicReadAllAction = function (appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var allCustomLogics, _e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch({ type: CUSTOM_LOGIC_READ_ALL.REQUEST });
                    if (!appId) return [3 /*break*/, 2];
                    return [4 /*yield*/, PatchworkService.getAllLogicPatchworks(appId)];
                case 1:
                    allCustomLogics = (_a.sent()).objects;
                    dispatch({
                        type: CUSTOM_LOGIC_READ_ALL.SUCCESS,
                        data: allCustomLogics,
                    });
                    _a.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    _e_4 = _a.sent();
                    dispatch({ type: CUSTOM_LOGIC_READ_ALL.ERROR });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var customLogicUpdateAction = function (customLogic) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedCustomLogic, _e_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    dispatch(setChangesLoadingState(true));
                    dispatch({
                        type: CUSTOM_LOGIC_UPDATE.REQUEST,
                        ref: customLogic.id,
                        data: customLogic,
                    });
                    if (!(customLogic === null || customLogic === void 0 ? void 0 : customLogic.id)) return [3 /*break*/, 2];
                    return [4 /*yield*/, PatchworkService.updatePatchwork(customLogic.id, customLogic)];
                case 1:
                    updatedCustomLogic = (_a.sent()).object;
                    dispatch({
                        type: CUSTOM_LOGIC_UPDATE.SUCCESS,
                        ref: updatedCustomLogic.id,
                        data: updatedCustomLogic,
                    });
                    _a.label = 2;
                case 2: return [3 /*break*/, 5];
                case 3:
                    _e_5 = _a.sent();
                    dispatch({ type: CUSTOM_LOGIC_UPDATE.ERROR, ref: customLogic.id });
                    return [3 /*break*/, 5];
                case 4:
                    dispatch(setChangesLoadingState());
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
export var customLogicRenameAction = function (customLogicId, customLogicName) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var customLogic, _e_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    dispatch(setChangesLoadingState(true));
                    return [4 /*yield*/, PatchworkService.readPatchwork(customLogicId)];
                case 1:
                    customLogic = (_a.sent()).object;
                    return [4 /*yield*/, dispatch(customLogicUpdateAction(__assign(__assign({}, customLogic), { name: customLogicName })))];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    _e_6 = _a.sent();
                    dispatch({ type: CUSTOM_LOGIC_UPDATE.ERROR, ref: customLogicId });
                    return [3 /*break*/, 5];
                case 4:
                    dispatch(setChangesLoadingState());
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
export var saveCustomLogicArgument = function (appId, customLogicId, blockId, arg, disableRefresh, silentUpdate) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var modifiedPatchwork, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, 7, 8]);
                    dispatch(setChangesLoadingState(true));
                    return [4 /*yield*/, PatchworkService.saveCustomLogicArgument(appId, customLogicId, blockId, arg)];
                case 1:
                    modifiedPatchwork = (_a.sent()).object;
                    if (!(!disableRefresh && modifiedPatchwork)) return [3 /*break*/, 5];
                    return [4 /*yield*/, dispatch(customLogicReadAction(modifiedPatchwork.id, true, undefined, !!silentUpdate))];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, dispatch(getPatchwork(appId))];
                case 3:
                    _a.sent();
                    if (!arg.name.includes('in:__')) return [3 /*break*/, 5];
                    return [4 /*yield*/, dispatch(setCustomLogicSubscription({
                            ref: customLogicId,
                            type: CUSTOM_LOGIC_SUBSCRIPTION_TYPE.ARG,
                        }))];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [3 /*break*/, 8];
                case 6:
                    err_1 = _a.sent();
                    dispatch({ type: CUSTOM_LOGIC_UPDATE.ERROR, ref: customLogicId });
                    return [3 /*break*/, 8];
                case 7:
                    dispatch(setChangesLoadingState());
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
};
export var customLogicSetForDeleteAction = function (ref) {
    return function (dispatch) {
        dispatch({ type: CUSTOM_LOGIC_DELETE.SET, ref: ref });
    };
};
export var customLogicDeleteAction = function (ref) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var _e_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    dispatch(setChangesLoadingState(true));
                    dispatch({ type: CUSTOM_LOGIC_DELETE.REQUEST, ref: ref });
                    if (!(ref === null || ref === void 0 ? void 0 : ref.id)) return [3 /*break*/, 2];
                    return [4 /*yield*/, PatchworkService.deletePatchwork(ref.id)];
                case 1:
                    _a.sent();
                    dispatch({ type: CUSTOM_LOGIC_DELETE.SUCCESS, ref: ref });
                    _a.label = 2;
                case 2: return [3 /*break*/, 5];
                case 3:
                    _e_7 = _a.sent();
                    dispatch({ type: CUSTOM_LOGIC_DELETE.ERROR, ref: ref });
                    return [3 /*break*/, 5];
                case 4:
                    dispatch(setChangesLoadingState());
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
export var resetCustomLogicDeleteStatusAction = function (dispatch) {
    dispatch({
        type: CUSTOM_LOGIC_DELETE.RESET,
    });
};
export var duplicateCustomLogicAction = function (appId, patchworkId, copyAppId, name) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var _e_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    dispatch(setChangesLoadingState(true));
                    dispatch({ type: DUPLICATE_CUSTOM_LOGIC.REQUEST });
                    return [4 /*yield*/, PatchworkService.duplicateLogicPatchwork(patchworkId, copyAppId, name)];
                case 1:
                    _a.sent();
                    if (appId === copyAppId) {
                        dispatch(customLogicReadAllAction(appId));
                    }
                    dispatch({ type: DUPLICATE_CUSTOM_LOGIC.SUCCESS });
                    return [3 /*break*/, 4];
                case 2:
                    _e_8 = _a.sent();
                    dispatch({ type: DUPLICATE_CUSTOM_LOGIC.ERROR });
                    return [3 /*break*/, 4];
                case 3:
                    dispatch(setChangesLoadingState());
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var resetDuplicateCustomLogicAction = function (dispatch) {
    dispatch({ type: DUPLICATE_CUSTOM_LOGIC.RESET });
};
//endregion
//region Block
export var blockCreateAction = function (customLogicId, block, connector) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var newCoreLogicBlock, originalConnector, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, 5, 6]);
                    dispatch(setChangesLoadingState(true));
                    dispatch({ type: BLOCK_CREATE.REQUEST });
                    block = cleanPatchOutputs(block);
                    if (!(customLogicId && block)) return [3 /*break*/, 3];
                    return [4 /*yield*/, PatchworkService.createPatch(customLogicId, __assign(__assign({}, block), { x: Math.floor(block.x), y: Math.floor(block.y) }))];
                case 1:
                    newCoreLogicBlock = (_a.sent()).object;
                    if (!(newCoreLogicBlock === null || newCoreLogicBlock === void 0 ? void 0 : newCoreLogicBlock.id)) return [3 /*break*/, 3];
                    dispatch({
                        type: BLOCK_CREATE.SUCCESS,
                        data: newCoreLogicBlock,
                    });
                    if (!(connector && (connector === null || connector === void 0 ? void 0 : connector.from_patch) && (connector === null || connector === void 0 ? void 0 : connector.from_arg))) return [3 /*break*/, 3];
                    originalConnector = cleanEdgeArgName(connector);
                    if (originalConnector) {
                        originalConnector = __assign(__assign({}, originalConnector), { to_patch: newCoreLogicBlock.id, to_arg: 'in:__view__' });
                    }
                    return [4 /*yield*/, dispatch(connectorCreateAction(customLogicId, originalConnector))];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [3 /*break*/, 6];
                case 4:
                    err_2 = _a.sent();
                    dispatch({ type: BLOCK_CREATE.ERROR });
                    return [3 /*break*/, 6];
                case 5:
                    dispatch(setChangesLoadingState());
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
};
export var resetBlockCreateStateAction = function (dispatch) {
    dispatch({
        type: BLOCK_CREATE.RESET,
    });
};
export var blockUpdateAction = function (appId, customLogicId, block) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var isOutputPatchRenaming, customLogic, patchInputArg, customLogicArg, incomingEdge, _e_9;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 8, 9, 10]);
                    dispatch(setChangesLoadingState(true));
                    isOutputPatchRenaming = block.type === 'logic' &&
                        (block === null || block === void 0 ? void 0 : block.logic) === 'output' &&
                        ((_a = block === null || block === void 0 ? void 0 : block.settings) === null || _a === void 0 ? void 0 : _a.toSync);
                    if (isOutputPatchRenaming) {
                        block.settings.toSync = false;
                    }
                    dispatch({
                        type: BLOCK_UPDATE.REQUEST,
                        data: block,
                        ref: block.id,
                    });
                    if (!(customLogicId && (block === null || block === void 0 ? void 0 : block.id))) return [3 /*break*/, 7];
                    return [4 /*yield*/, PatchworkService.updatePatch(customLogicId, block.id, block)];
                case 1:
                    customLogic = (_c.sent()).object;
                    if (!isOutputPatchRenaming) return [3 /*break*/, 5];
                    patchInputArg = "out:__".concat(block.name
                        .replace(' ', '_')
                        .replace(/[^a-zA-Z0-9]+(.)/g, function (_, chr) { return chr.toUpperCase(); }), "__");
                    customLogicArg = {
                        name: patchInputArg,
                        type: 'event',
                        value: [],
                    };
                    if (!customLogic) return [3 /*break*/, 3];
                    incomingEdge = (_b = customLogic === null || customLogic === void 0 ? void 0 : customLogic.edges) === null || _b === void 0 ? void 0 : _b.find(function (edge) {
                        return edge.to_patch === block.id && edge.to_arg === 'in:__view__';
                    });
                    if (!incomingEdge) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(connectorUpdateAction(customLogic.id, incomingEdge.id, __assign(__assign({}, incomingEdge), { to_arg: patchInputArg.replace('out:', 'in:') })))];
                case 2:
                    _c.sent();
                    _c.label = 3;
                case 3:
                    dispatch({
                        type: BLOCK_UPDATE.SUCCESS,
                        data: customLogic,
                        ref: block.id,
                    });
                    return [4 /*yield*/, dispatch(saveCustomLogicArgument(appId, customLogicId, block.id, customLogicArg))];
                case 4:
                    _c.sent();
                    return [3 /*break*/, 7];
                case 5:
                    if (!((block === null || block === void 0 ? void 0 : block.logic) === 'output')) return [3 /*break*/, 7];
                    dispatch({
                        type: BLOCK_UPDATE.SUCCESS,
                        data: customLogic,
                        ref: block.id,
                    });
                    return [4 /*yield*/, dispatch(getPatchwork(appId))];
                case 6:
                    _c.sent();
                    _c.label = 7;
                case 7: return [3 /*break*/, 10];
                case 8:
                    _e_9 = _c.sent();
                    dispatch({ type: BLOCK_UPDATE.ERROR, ref: block.id });
                    return [3 /*break*/, 10];
                case 9:
                    dispatch(setChangesLoadingState());
                    return [7 /*endfinally*/];
                case 10: return [2 /*return*/];
            }
        });
    }); };
};
export var blockAutoAlignAction = function (customLogicId, batch) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var modifiedCustomLogic, _e_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    dispatch(setChangesLoadingState(true));
                    dispatch({ type: BLOCK_UPDATE.REQUEST });
                    if (!(customLogicId && batch)) return [3 /*break*/, 2];
                    return [4 /*yield*/, PatchworkService.updatePatchCoordinates(customLogicId, batch)];
                case 1:
                    modifiedCustomLogic = (_a.sent()).object;
                    if (modifiedCustomLogic === null || modifiedCustomLogic === void 0 ? void 0 : modifiedCustomLogic.id) {
                        dispatch({
                            type: BLOCK_UPDATE.SUCCESS,
                            data: modifiedCustomLogic,
                        });
                    }
                    _a.label = 2;
                case 2: return [3 /*break*/, 5];
                case 3:
                    _e_10 = _a.sent();
                    dispatch({ type: BLOCK_UPDATE.ERROR });
                    return [3 /*break*/, 5];
                case 4:
                    dispatch(setChangesLoadingState());
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
export var resetBlockUpdateStateAction = function (dispatch) {
    dispatch({
        type: BLOCK_UPDATE.RESET,
    });
};
export var blockDeleteAction = function (appId, customLogicId, blockId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var _e_11;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, 5, 6]);
                    dispatch(setChangesLoadingState(true));
                    dispatch({ type: BLOCK_DELETE.REQUEST, ref: blockId });
                    if (!(customLogicId && blockId)) return [3 /*break*/, 3];
                    return [4 /*yield*/, PatchworkService.deletePatch(customLogicId, blockId)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, dispatch(customLogicReadAction(customLogicId, true, function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, dispatch(getPatchwork(appId))];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 2:
                    _a.sent();
                    dispatch({ type: BLOCK_DELETE.SUCCESS, ref: blockId });
                    _a.label = 3;
                case 3: return [3 /*break*/, 6];
                case 4:
                    _e_11 = _a.sent();
                    dispatch({ type: BLOCK_DELETE.ERROR, ref: blockId });
                    return [3 /*break*/, 6];
                case 5:
                    dispatch(setChangesLoadingState());
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
};
export var resetBlockDeleteStateAction = function (dispatch) {
    dispatch({
        type: BLOCK_DELETE.RESET,
    });
};
export var blockDuplicateAction = function (clone, currentCustomLogic) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var _e_12;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 7, 8, 9]);
                    dispatch(setChangesLoadingState(true));
                    dispatch({ type: BLOCK_DUPLICATE.REQUEST });
                    if (!((clone === null || clone === void 0 ? void 0 : clone.copiedPatchworkId) && (clone === null || clone === void 0 ? void 0 : clone.patches))) return [3 /*break*/, 6];
                    return [4 /*yield*/, PatchworkService.postCopiedMonoPatch(clone)];
                case 1:
                    _a.sent();
                    if (!((clone === null || clone === void 0 ? void 0 : clone.logic) === 'output')) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(customLogicReadAction(clone === null || clone === void 0 ? void 0 : clone.copiedPatchworkId, true, function (newCustomLogic) { return __awaiter(void 0, void 0, void 0, function () {
                            var newPatch, patchInputArg, customLogicArg;
                            var _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        newPatch = differenceBy((_a = newCustomLogic === null || newCustomLogic === void 0 ? void 0 : newCustomLogic.patches) !== null && _a !== void 0 ? _a : [], (_b = currentCustomLogic === null || currentCustomLogic === void 0 ? void 0 : currentCustomLogic.patches) !== null && _b !== void 0 ? _b : [], 'id')[0];
                                        patchInputArg = "out:__".concat(newPatch.name
                                            .replace(' ', '_')
                                            .replace(/[^a-zA-Z0-9]+(.)/g, function (_, chr) {
                                            return chr.toUpperCase();
                                        }), "__");
                                        customLogicArg = {
                                            name: patchInputArg,
                                            type: 'event',
                                            value: [],
                                        };
                                        return [4 /*yield*/, dispatch(saveCustomLogicArgument(clone === null || clone === void 0 ? void 0 : clone.appId, clone === null || clone === void 0 ? void 0 : clone.copiedPatchworkId, newPatch.id, customLogicArg))];
                                    case 1:
                                        _c.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, dispatch(customLogicReadAction(clone === null || clone === void 0 ? void 0 : clone.copiedPatchworkId, true))];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    dispatch({ type: BLOCK_DUPLICATE.SUCCESS });
                    toast.success("Successfully pasted");
                    _a.label = 6;
                case 6: return [3 /*break*/, 9];
                case 7:
                    _e_12 = _a.sent();
                    dispatch({ type: BLOCK_DUPLICATE.ERROR });
                    return [3 /*break*/, 9];
                case 8:
                    dispatch(setChangesLoadingState());
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
};
export var resetBlockDuplicateStateAction = function (dispatch) {
    dispatch({
        type: BLOCK_DUPLICATE.RESET,
    });
};
//endregion
//region Connector
export var connectorCreateAction = function (customLogicId, connector) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var newConnector, _e_13;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    dispatch(setChangesLoadingState(true));
                    dispatch({ type: CONNECTOR_CREATE.REQUEST });
                    if (!(customLogicId && connector)) return [3 /*break*/, 2];
                    connector.from_arg = appendOutToName(connector.from_arg);
                    return [4 /*yield*/, PatchworkService.createEdge(customLogicId, connector)];
                case 1:
                    newConnector = (_a.sent()).object;
                    if (newConnector === null || newConnector === void 0 ? void 0 : newConnector.id) {
                        dispatch({ type: CONNECTOR_CREATE.SUCCESS, data: newConnector });
                    }
                    _a.label = 2;
                case 2: return [3 /*break*/, 5];
                case 3:
                    _e_13 = _a.sent();
                    dispatch({ type: CONNECTOR_CREATE.ERROR });
                    return [3 /*break*/, 5];
                case 4:
                    dispatch(setChangesLoadingState());
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
export var resetConnectorCreateStateAction = function (dispatch) {
    dispatch({
        type: CONNECTOR_CREATE.RESET,
    });
};
export var connectorUpdateAction = function (customLogicId, connectorId, connector) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var cleanConnector, newConnector, _e_14;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    dispatch(setChangesLoadingState(true));
                    dispatch({ type: CONNECTOR_UPDATE.REQUEST });
                    if (!(customLogicId && connectorId && connector)) return [3 /*break*/, 2];
                    cleanConnector = __assign(__assign({}, connector), { from_arg: appendOutToName(connector.from_arg) });
                    return [4 /*yield*/, PatchworkService.updateEdge(customLogicId, connectorId, cleanConnector)];
                case 1:
                    newConnector = (_a.sent()).object;
                    if (newConnector === null || newConnector === void 0 ? void 0 : newConnector.id) {
                        dispatch({ type: CONNECTOR_UPDATE.SUCCESS, data: newConnector });
                    }
                    _a.label = 2;
                case 2: return [3 /*break*/, 5];
                case 3:
                    _e_14 = _a.sent();
                    dispatch({ type: CONNECTOR_UPDATE.ERROR });
                    return [3 /*break*/, 5];
                case 4:
                    dispatch(setChangesLoadingState());
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
export var resetConnectorUpdateStateAction = function (dispatch) {
    dispatch({
        type: CONNECTOR_UPDATE.RESET,
    });
};
export var connectorDeleteAction = function (customLogicId, connectorId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var _e_15;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, 5, 6]);
                    dispatch(setChangesLoadingState(true));
                    dispatch({ type: CONNECTOR_DELETE.REQUEST, ref: connectorId });
                    if (!(customLogicId && connectorId)) return [3 /*break*/, 3];
                    return [4 /*yield*/, PatchworkService.deleteEdge(customLogicId, connectorId)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, dispatch(customLogicReadAction(customLogicId))];
                case 2:
                    _a.sent();
                    dispatch({ type: CONNECTOR_DELETE.SUCCESS, ref: connectorId });
                    _a.label = 3;
                case 3: return [3 /*break*/, 6];
                case 4:
                    _e_15 = _a.sent();
                    dispatch({ type: CONNECTOR_DELETE.ERROR, ref: connectorId });
                    return [3 /*break*/, 6];
                case 5:
                    dispatch(setChangesLoadingState());
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
};
export var resetConnectorDeleteStateAction = function (dispatch) {
    dispatch({
        type: CONNECTOR_DELETE.RESET,
    });
};
//endregion
